export const initialCartState = {
  subTotalTitle: "",
  bagTotalTitle: "",
  bagDiscountTitle: "",
  discountTitle: "",
  grandTotalTitle: "",
  bagTotal: 0,
  subTotal: 0,
  bagDiscount: 0,
  discount: 0,
  totalSaved: 0,
  grandTotal: 0,
  customerEmail: "",
  contactNumber: "",
  rewardPointsRecieve: "",
  shippingAddress: null,
  cartErrorMessage: "",
  shippingText: "",
  internationalShippingData: "",
  availablePaymentMethods: [],
  isCodAvailable: false,
  cartOfferKey: "",
  cartOfferMessage: "",
  codMessage: "",
  infoMessage: "",
  ngsMessage: "",
  isNgsProduct: false,
  paymentDetails: {},
  couponDiscount: 0,
  shippingCharge: 0,
  quantity: 0,
  paymentTags: [],
  currencyCode: '',
  cartConvenienceChargesBreakupDto: []
};

export const initialPaymentInfoState = {
  razorPayKey: "",
  emiInfo: {
    emiDisabledMsg: "",
    emiInfoMsg: "",
    emiMinLimit: "",
    isNoCostEmiAvailable: false,
  },
  simplDTO: {},
  isCardS2SFlowEnabled: true,
  upiMapping: []
};

export const initialCartOfferState = {
  paymentRules: [],
  nonEligiblePaymentRules: [],
  customerType: null,
};

export const initialWalletState = {
  scWalletFlag: 0,
  scWalletEnabled: false,
  contactNumber: 0,
  balance: 0,
  walletMessages: {
    info: "",
    failure: "",
  },
  isVerificationRequired: false,
};

export const ALERT_PAYMENT_MODE = {
  UPI: 'upi',
  NET_BANKING: 'nb',
  CC_DC: 'cc',
  MOBILE_WALLETS: 'wallet',
};

export const ALERT_PAYMENT_MODE_VALUE = {
  UPI: 'BHIM',
  NET_BANKING: 'Net Banking',
  CC_DC: 'Credit/Debit card',
  MOBILE_WALLETS: 'Mobile Wallets',
  GOOGLE_PAY: 'Google Pay',
};

export const ALERT_PAYMENT_STATUS = {
  DISABLE: 0,
  NORMAL: 1,
  WARNING: 2,
  HIDE: 3,
};

/**
 * These are the constants for payment alert messaging.
 */

export const PAYMENT_ALERT_MESSAGE = {
  PAYMENT_METHOD_EXPERIENCING_ISSUES: "Payment method experiencing issues"
}

export const INTENT_NO_APPS_ERROR = "intent_no_apps_error";
export const NO_APPS_ERROR_MESSAGE = "Unable to detect UPI app.";

/**
 * upi intent merchant names
 */
export const merchantNames = {
  paytm: "Paytm",
  gpay: "Google Pay",
  phonepe: "PhonePe",
};

/**
 * upi intent merchant key
 */
export const merchantKeys: { [key: string]: string } = {
  [merchantNames.paytm]: "paytm",
  [merchantNames.gpay]: "gpay",
  [merchantNames.phonepe]: "phonepe",
};